import { PageContainer } from '../../shared/PageContainer';
import StadiumIcon from '@mui/icons-material/Stadium';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { loadTracks } from '../../../redux/track/trackAction';
import { trackState } from '../../../redux/track/trackSlice';
import { Box } from '@mui/material';
import { TrackPageActions } from './TrackPageActions';
import { useSearchParams } from 'react-router-dom';
import { getSearchCategory, getSearchProvider, initialSearchParams, updateSearchParamsForCategory, updateSearchParamsForProvider } from './trackPageHelper';
import { categoryItems } from '../../shared/sharedHelper';
import { commonState } from '../../../redux/common/commonSlice';
import { TrackList } from '../trackList/TrackList';
import { LoadingBackground } from '../../shared/LoadingBackground';
import { useEffect } from 'react';

export const TrackPage = () => {

    const state = useAppSelector(trackState);
    const common = useAppSelector(commonState);
    const dispatch = useAppDispatch();

    const [searchParams, setSearchParams] = useSearchParams();

    const searchProvider = getSearchProvider(searchParams);
    const searchCategory = getSearchCategory(searchParams);

    const loadPageTracks = async () => {
        if (searchProvider) {
            await dispatch(loadTracks(searchProvider));
        }
    }

    const handleSearchProviderChange = (providerCode: string) => {
        setSearchParams(updateSearchParamsForProvider(searchParams, providerCode));
    }

    const handleSearchCategoryChange = (categoryCode: string) => {
        setSearchParams(updateSearchParamsForCategory(searchParams, categoryCode));
    }

    const getDisplayTracks = () => {
        const filteredTracks = state.tracks.filter((t) =>
            t.categoryCode === searchCategory &&
            t.provider === searchProvider
        );
        return filteredTracks.toSorted((a, b) => ((a.shortDescription!.toLowerCase() < b.shortDescription!.toLowerCase() ? -1 : 1)));
    }

    const handleRefresh = async () => {
        loadPageTracks();
    }

    const tracks = getDisplayTracks();

        useEffect(() => {
        initialSearchParams(searchParams, common, setSearchParams);
    },[common, searchParams, setSearchParams])

    useEffect(() => {
        loadPageTracks();
        // We want to restrict only on searchProvider
        // eslint-disable-next-line
    }, [searchProvider]);

    return (
        <PageContainer
            heading='Track Codes'
            icon={<StadiumIcon />}
            rightElement={
                <TrackPageActions
                    providerCode={searchProvider ?? ''}
                    categoryCode={searchCategory ?? categoryItems[0].key}
                    onProviderCodeChange={handleSearchProviderChange}
                    onCategoryCodeChange={handleSearchCategoryChange}
                    onRefresh={handleRefresh}
                />
            }
        >
            {state.loading &&
                <LoadingBackground top='150px' left='calc(50% - 24px)' />
            }
            <Box sx={{ opacity: state.loading ? 0.4 : 1 }}>
                <TrackList provider={searchProvider ?? ''} tracks={tracks} />
            </Box>
        </PageContainer>
    )
}
